export const getEnvVariable = (key) => {
    if (process.env.NODE_ENV === 'production') {
      return window[`REACT_APP_${key}`];
    }
    return process.env[`REACT_APP_${key}`];
  };